import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import Close from '../../Icons/CloseV2';
import Logo from '../../Logo';
import BackToPG from '../../Icons/BackToPG';
import LogOut from '../../Icons/LogOut';
import styles from '../Navigation.css';
import { trackPUAnalytics } from '../../../services/Mixpanel';

const NavigationMobileSider = ({
  isMobile,
  isTablet,
  isSiderOpen,
  active,
  setIsSiderOpen,
  setActive,
  me,
  mainNavLinks,
  rightMenuLinks,
  history,
  pgHomeLink,
  windowWidth,
}) => {
  useEffect(() => {
    const body = document.querySelector('body');

    if (isSiderOpen) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = 'auto';
    }

    return () => {
      body.style.overflow = 'auto';
    };
  }, [isSiderOpen]);

  if (!isMobile && !isTablet) return null;

  const handleMenuClick = (id, path) => {
    if (id === 'backToPG' && path) {
      window.location.href = path;
      return;
    }
    if (id === 'logout') {
      trackPUAnalytics('PathwayU:LogOut', { pageLocation: window.location.href });
    }
    setActive(id);
    history.push(path);
    setIsSiderOpen(false);
  };

  let siderWidth = 0.8 * windowWidth;
  if (siderWidth > 314) siderWidth = 314;
  if (siderWidth < 200) siderWidth = 200;

  return (
    <div
      className={cx(styles.sider, {
        [styles.siderOpen]: isSiderOpen,
      })}
      style={{ width: `${siderWidth}px` }}
    >
      <div className={styles.siderChildren}>
        <div className={styles.siderTop}>
          {pgHomeLink ? (
            <button
              className={styles.siderBackToPG}
              onClick={() => handleMenuClick('backToPG', pgHomeLink)}
            >
              <BackToPG />
                            Home
            </button>
          ) : null}
          <span className={styles.siderLogo}>
            <Logo className={styles.siderLogoItem} />
          </span>
        </div>
        <div className={styles.siderHeader}>
          <span className={styles.siderUsername}>
            {me.firstName} {me.lastName}
          </span>
          <button
            className={styles.siderCloseButton}
            aria-label="Close Main Menu"
            onClick={() => setIsSiderOpen(false)}
          >
            <Close />
          </button>
        </div>
        <div className={styles.siderMainBody}>
          <ul
            role="menu"
            className={styles.siderMainMenu}
            style={{ padding: '16px 0 0 0' }}
          >
            {(mainNavLinks || []).map(({ id, path, name }) => (
              <li
                key={id}
                role="menuitem"
                className={cx(styles.siderMainMenuItem, {
                  [styles.siderMainMenuItemSelected]: active === id,
                })}
              >
                <button onClick={() => handleMenuClick(id, path)}>{name}</button>
              </li>
            ))}
          </ul>
          <div className={styles.siderSeparatorContainer}>
            <div className={styles.siderSeparator} />
          </div>
          <ul role="menu" className={styles.siderMainMenu}>
            {(rightMenuLinks || [])
              .filter(({ id }) => id !== 'logout')
              .map(({ id, path, name }) => (
                <li
                  key={id}
                  role="menuitem"
                  className={cx(styles.siderMainMenuItem, {
                    [styles.siderMainMenuItemSelected]: active === id,
                  })}
                >
                  <button onClick={() => handleMenuClick(id, path)}>{name}</button>
                </li>
              ))}
          </ul>
          <div className={styles.siderSeparatorContainer}>
            <div className={styles.siderSeparator} />
          </div>
          <ul role="menu" className={styles.siderMainMenu}>
            <li
              role="menuitem"
              className={styles.siderMainMenuItem}
            >
              <button onClick={() => handleMenuClick('logout', '/logout')}>
                <span>Log Out</span>
                <LogOut />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

NavigationMobileSider.propTypes = {
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  isSiderOpen: PropTypes.bool,
  active: PropTypes.string,
  setIsSiderOpen: PropTypes.func,
  setActive: PropTypes.func,
  me: PropTypes.object,
  mainNavLinks:
        PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            path: PropTypes.string,
            isExact: PropTypes.bool,
          }),
        ),
  rightMenuLinks:
        PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            path: PropTypes.string,
            isExact: PropTypes.bool,
          }),
        ),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  pgHomeLink: PropTypes.oneOfType(
    [PropTypes.string, PropTypes.oneOf([null])],
  ),
  windowWidth: PropTypes.number,
};

export default compose(
  withRouter,
  connect(({ windowState }) => ({
    windowWidth: windowState.windowWidth,
  })),
)(NavigationMobileSider);



// WEBPACK FOOTER //
// ./src/client/Components/Navigation/components/NavigationMobileSider.js